import { ChevronLeft, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ESTADOS, LABEL } from "./constants";

// Confirmación para retroceder estado del vehículo (presentacional puro).
export const RegresarModal = ({ regresarTarget, setRegresarTarget, confirmarRegresar, regresando }) => (
  <Dialog open={!!regresarTarget} onOpenChange={(o) => !o && setRegresarTarget(null)}>
    <DialogContent className="rounded-none border-[#EF4444]/40 bg-[#0A0A0A] text-white max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="valet-regresar-modal">
      <DialogHeader>
        <DialogTitle className="font-display font-black text-white text-xl">Retroceder estado del vehículo</DialogTitle>
        <DialogDescription className="text-white/70 text-sm leading-relaxed">
          ¿Seguro que deseas regresar este vehículo al estado anterior?
          {regresarTarget && (
            <span className="block mt-2 text-white/50">
              {LABEL[regresarTarget.estado_valet]} → <b className="text-[#FFCC00]">{LABEL[ESTADOS[Math.max(0, ESTADOS.indexOf(regresarTarget.estado_valet) - 1)]]}</b> · Folio {regresarTarget.folio_impreso}
            </span>
          )}
        </DialogDescription>
      </DialogHeader>
      <div className="flex gap-2 pt-2">
        <button onClick={() => setRegresarTarget(null)} data-testid="valet-regresar-cancel"
          className="flex-1 h-11 border border-white/20 text-white/70 text-xs font-bold uppercase tracking-wider hover:bg-white/5">
          Cancelar
        </button>
        <button onClick={confirmarRegresar} disabled={regresando} data-testid="valet-regresar-confirm"
          className="btn-hard flex-1 h-11 bg-[#EF4444] text-white border border-[#EF4444] font-bold uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60">
          {regresando ? <Loader2 className="h-4 w-4 animate-spin" /> : <><ChevronLeft className="h-4 w-4" /> Sí, regresar</>}
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default RegresarModal;
